module.exports = __webpack_public_path__ + "images/TRICYCLE.82b8fd43335e00d4181bfcebf8f13a02.png";